import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const AfterSaleService = () => {
  const services = [
    {
      icon: 'fas fa-headset',
      title: '24/7 Support',
      description: 'Round-the-clock technical support and emergency assistance for critical equipment.',
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      response: '< 2 Hours',
      availability: '24/7'
    },
    {
      icon: 'fas fa-calendar-check',
      title: 'Preventive Maintenance',
      description: 'Scheduled maintenance programs to prevent breakdowns and extend equipment life.',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      response: 'Scheduled',
      availability: 'Flexible'
    },
    {
      icon: 'fas fa-tools',
      title: 'Emergency Repairs',
      description: 'Rapid response emergency repair services to minimize downtime and restore operations.',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      response: '< 4 Hours',
      availability: '24/7'
    },
    {
      icon: 'fas fa-shipping-fast',
      title: 'Parts Supply',
      description: 'Comprehensive parts inventory and fast delivery to keep your equipment running.',
      image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      response: 'Same Day',
      availability: 'Business Hours'
    }
  ];

  const equipment = [
    {
      category: 'Kitchen Equipment',
      items: ['Microwave Ovens', 'Flour Mixers', 'Blenders', 'Gas Stoves', 'Commercial Ovens'],
      icon: 'fas fa-utensils',
      image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      category: 'Home Appliances',
      items: ['Washing Machines', 'Refrigerators', 'Air Conditioners', 'Televisions', 'Curtain Systems'],
      icon: 'fas fa-home',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      category: 'Ventilation Systems',
      items: ['Desktop Fans', 'Ceiling Fans', 'Wall Fans', 'Stand Fans', 'Industrial Fans'],
      icon: 'fas fa-fan',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Service Request',
      description: 'Contact us via phone, email, or online portal to report issues or schedule service.',
      icon: 'fas fa-phone'
    },
    {
      step: '02',
      title: 'Diagnosis',
      description: 'Our technicians perform thorough diagnosis to identify the root cause of issues.',
      icon: 'fas fa-search'
    },
    {
      step: '03',
      title: 'Repair & Maintenance',
      description: 'Professional repair work using genuine parts and industry best practices.',
      icon: 'fas fa-wrench'
    },
    {
      step: '04',
      title: 'Quality Assurance',
      description: 'Comprehensive testing and quality checks to ensure optimal performance.',
      icon: 'fas fa-check-circle'
    }
  ];

  const gallery = [
    'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  ];

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section className="service-hero parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="After Sale Service" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="hero-content"
            >
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <Link to="/services">Services</Link>
                <span>/</span>
                <span>After Sale Service</span>
              </div>
              <h1>After Sale Service</h1>
              <h2>Complete Support Solutions</h2>
              <p>Comprehensive after-sales support including maintenance, repairs, and technical assistance to keep your equipment running at peak performance.</p>
              <div className="hero-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Get Support <i className="fas fa-arrow-right"></i>
                </Link>
                <a href="tel:+1234567890" className="btn btn-secondary">
                  Emergency: Call Now <i className="fas fa-phone"></i>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="service-overview section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Comprehensive Support Services</h2>
              <p className="section-subtitle">
                Dedicated support to maximize equipment performance and minimize downtime
              </p>
            </motion.div>

            <div className="overview-content">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="overview-text"
              >
                <h3>Your Equipment, Our Priority</h3>
                <p>
                  Our after-sales service team is committed to ensuring your equipment operates at peak 
                  performance throughout its lifecycle. With experienced technicians, comprehensive parts 
                  inventory, and 24/7 support, we provide the reliability you need to keep your operations running smoothly.
                </p>
                <p>
                  From routine maintenance to emergency repairs, our service programs are designed to 
                  prevent problems before they occur and resolve issues quickly when they arise. 
                  We understand that equipment downtime costs money, which is why we prioritize rapid response and effective solutions.
                </p>
                <div className="key-benefits">
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>24/7 Emergency Support</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Genuine Parts Guarantee</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Certified Technicians</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Preventive Maintenance</span>
                  </div>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="overview-image"
              >
                <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="After Sale Service Overview" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Types */}
      <section className="service-features section parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Services Background" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Service Types</h2>
              <p className="section-subtitle">
                Comprehensive support services tailored to your equipment needs
              </p>
            </motion.div>

            <div className="services-grid">
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="service-type-card card-hover-lift card-glow"
                  whileHover={{ y: -10 }}
                >
                  <div className="service-type-image">
                    <img src={service.image} alt={service.title} />
                    <div className="service-type-overlay">
                      <i className={service.icon}></i>
                    </div>
                  </div>
                  <div className="service-type-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-type-details">
                      <div className="detail-item">
                        <i className="fas fa-clock"></i>
                        <span>Response: {service.response}</span>
                      </div>
                      <div className="detail-item">
                        <i className="fas fa-calendar"></i>
                        <span>{service.availability}</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Coverage */}
      <section className="service-overview section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Equipment Coverage</h2>
              <p className="section-subtitle">
                We service a wide range of equipment across different categories
              </p>
            </motion.div>

            <div className="equipment-grid">
              {equipment.map((category, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="equipment-card card-hover-lift"
                  whileHover={{ y: -10 }}
                >
                  <div className="equipment-image">
                    <img src={category.image} alt={category.category} />
                    <div className="equipment-overlay">
                      <i className={category.icon}></i>
                    </div>
                  </div>
                  <div className="equipment-content">
                    <h3>{category.category}</h3>
                    <ul className="equipment-list">
                      {category.items.map((item, idx) => (
                        <li key={idx}>
                          <i className="fas fa-check"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="service-process section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Service Process</h2>
              <p className="section-subtitle">
                Our streamlined process ensures quick and effective service delivery
              </p>
            </motion.div>

            <div className="process-timeline">
              {process.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  className="process-step"
                >
                  <div className="step-number">{step.step}</div>
                  <div className="step-icon">
                    <i className={step.icon}></i>
                  </div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="service-gallery section parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Gallery Background" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Service Gallery</h2>
              <p className="section-subtitle">
                Our technicians at work providing quality service and support
              </p>
            </motion.div>

            <div className="gallery-grid">
              {gallery.map((image, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="gallery-item"
                  whileHover={{ scale: 1.05 }}
                >
                  <img src={image} alt={`Service ${index + 1}`} />
                  <div className="gallery-overlay">
                    <i className="fas fa-search-plus"></i>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="cta-content"
            >
              <h2>Need Service Support?</h2>
              <p>Our expert technicians are ready to help with all your equipment service needs</p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Request Service
                </Link>
                <a href="tel:+1234567890" className="btn btn-secondary">
                  Emergency Support
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AfterSaleService;